<template>
  <div id="app">
    <thermo-map access-token="pk.eyJ1IjoibWhvZmJhdWVyIiwiYSI6ImNpbmlvOW9zYTAwM3R3MmtsdzQzNmlhaHQifQ.U68SeYBseY3_lMpr7fY3Sg"></thermo-map>
  </div>
</template>

<script>
import ThermoMap from './components/ThermoMap.vue'

export default {
  name: 'app',
  baseUrl: '/thermomap/',
  components: {
    ThermoMap
  }
}
</script>

<style lang="scss">
html, body {
  height: 100%;
}
body {
  margin: 0;
  padding: 0;

}
#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  // margin-top: 60px;
  height: 100%;
}
</style>
